import { ajax } from 'utils';
import { getList } from './outWorkbench';
import _ from 'lodash';
import { showAlert } from '@beehive/components';
import { changeListFinishType } from '../actions/outWorkbench';
import { GrayConfigModule, hasGrayConfigWithoutGroup } from 'utils/gray';

export function projectMoveTrunk(body: any, options: any = {}) {
  const { menuKey, grayKey, throwFullError = false } = options;
  const grayConfigKey = _.snakeCase(grayKey || menuKey);

  return {
    types: [null, null, null],
    promise: () => ajax({
      url: 'outsource/v2/java_proxy/demands_move/move',
      method: 'POST',
      body,
    }).then((res: any) => {
      if (res.data && res.data.full_message) {
        throw throwFullError ? res.data : res.data.full_message.join(',');
      }
      return res;
    }),
  };
}

export function projectMove(body: any, options: any = {}) {
  const { menuKey } = options;

  return (dispatch: any, getState: any) => {
    const promise = dispatch(projectMoveTrunk(body, options));
    if (menuKey && promise.then) {
      promise.then((res: any) => {
        dispatch(refreshList(menuKey));
        return res;
      });
    }
    return promise;
  };
}

export function projectDeleteTrunk(id: string | number) {
  return {
    types: [null, null, null],
    promise: () => ajax({
      url: `v2/demands/${id}`,
      method: 'DELETE',
    }),
  };
}

export function projectDelete(id: string | number, options: any = {}) {
  const { menuKey } = options;
  return (dispatch: any, getState: any) => {
    const promise = dispatch(projectDeleteTrunk(id));
    if (menuKey && promise.then) {
      promise.then((res: any) => {
        dispatch(refreshList(menuKey));
        return res;
      });
    }
    return promise;
  };
}

export function changeFinishTypeTrunk(body: any) {
  return {
    types: [null, null, null],
    promise: () =>
      ajax({
        url: 'outsource/v2/demands/processed',
        method: 'POST',
        body,
      }),
  };
}

export function changeFinishType(menuKey: string, options: any) {
  return (dispatch: any, getState: any) => {
    const { isChecked, id } = options;
    const promise = dispatch(
      changeFinishTypeTrunk({ finished: isChecked, id }),
    );
    if (menuKey && promise.then) {
      promise.then((res: any) => {
        showAlert({
          type: 'success',
          message: res.res_msg,
        });
        dispatch(changeListFinishType({ menuKey: _.snakeCase(menuKey), id }));
        return res;
      });
    }
    return promise;
  };
}

export function refreshList(menuKey: string) {
  return (dispatch: any, getState: any) => {
    const data = _.get(getState(), `outWorkbench.${_.snakeCase(menuKey)}`, {});
    const { conditions = {}, list = {} } = data;
    const { current_page = 1, page_size = 15 } = list;
    dispatch(getList(_.snakeCase(menuKey), conditions, { current_page, page_size }));
  };
}
